<template>
  <div
    class="table-responsive"
    v-if="currentUser"
  >
    <table class="table table-striped table-hover">
      <tbody>
        <tr>
          <th>{{ $t('fields.id_card') }}</th>
          <td>{{ currentUser.id_card || $t('string.na') }}</td>
        </tr>
        <tr>
          <th>{{ $t('fields.name') }}</th>
          <td>{{ currentUser.name }}</td>
        </tr>
        <tr>
          <th>{{ $t('fields.email') }}</th>
          <td>{{ currentUser.email }}</td>
        </tr>
        <tr>
          <th>{{ $t('fields.emailVerifiedAt') }}</th>
          <td>{{ currentUser.email_verified_at === null ? $t('string.na') : currentUser.email_verified_at }}</td>
        </tr>
        <tr>
          <th>{{ $t('fields.createdAt') }}</th>
          <td>{{ currentUser.created_at }}</td>
        </tr>
        <tr>
          <th>{{ $t('fields.updatedAt') }}</th>
          <td>{{ currentUser.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Profile',
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  }
}
</script>

<style scoped>

</style>
